import * as React from "react"
export const Svg_032 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M29.5 59c2.715 0 5.508-2.947 7.662-8.086 1.117-2.666 2-5.752 2.622-9.114H19.216c.622 3.362 1.505 6.448 2.622 9.114C23.992 56.053 26.785 59 29.5 59Z"
      />
      <path
        fill="url(#c)"
        d="M15.707 41.8H2.669a29.505 29.505 0 0 0 5.971 8.56c3.732 3.731 8.287 6.34 13.256 7.656-1.195-1.546-2.287-3.477-3.246-5.766-1.28-3.052-2.271-6.597-2.943-10.45Z"
      />
      <path
        fill="url(#d)"
        d="M43.293 17.2h13.038a29.506 29.506 0 0 0-5.971-8.56C46.628 4.91 42.073 2.3 37.105.984 38.299 2.53 39.39 4.461 40.35 6.75c1.28 3.052 2.271 6.597 2.943 10.45Z"
      />
      <path
        fill="url(#e)"
        d="M44.318 29.5c0 3.03-.176 6-.517 8.843h13.857A29.59 29.59 0 0 0 59 29.5c0-3.045-.458-6.018-1.342-8.844H43.8c.342 2.844.518 5.813.518 8.844Z"
      />
      <path
        fill="url(#f)"
        d="M40.35 52.25c-.96 2.289-2.051 4.22-3.245 5.766 4.968-1.316 9.523-3.925 13.255-7.656a29.504 29.504 0 0 0 5.97-8.56H43.294c-.672 3.853-1.664 7.398-2.943 10.45Z"
      />
      <path
        fill="url(#g)"
        d="M29.5 0c-2.715 0-5.508 2.947-7.662 8.086-1.117 2.666-2 5.752-2.622 9.114h20.568c-.622-3.362-1.505-6.448-2.622-9.114C35.008 2.947 32.215 0 29.5 0Z"
      />
      <path
        fill="url(#h)"
        d="M14.682 29.5c0-3.03.176-6 .518-8.844H1.341A29.589 29.589 0 0 0 0 29.5c0 3.044.458 6.018 1.342 8.843H15.2a74.408 74.408 0 0 1-.518-8.843Z"
      />
      <path
        fill="url(#i)"
        d="M18.65 6.75c.96-2.289 2.051-4.22 3.245-5.766C16.927 2.3 12.372 4.909 8.64 8.64a29.506 29.506 0 0 0-5.97 8.56h13.037c.672-3.853 1.664-7.398 2.943-10.45Z"
      />
      <path
        fill="url(#j)"
        d="M18.68 38.343h21.64c.357-2.826.541-5.799.541-8.843 0-3.045-.184-6.017-.541-8.844H18.68a70.856 70.856 0 0 0-.541 8.844c0 3.044.184 6.017.541 8.843Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={23.972}
        x2={31.423}
        y1={44.38}
        y2={58.801}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={7.116}
        x2={14.175}
        y1={44.233}
        y2={57.779}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={41.55}
        x2={48.61}
        y1={3.416}
        y2={16.962}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={47.315}
        x2={56.221}
        y1={23.309}
        y2={35.695}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={41.551}
        x2={48.61}
        y1={44.233}
        y2={57.779}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={23.972}
        x2={31.423}
        y1={2.58}
        y2={17}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={3.515}
        x2={12.42}
        y1={23.309}
        y2={35.695}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={7.115}
        x2={14.175}
        y1={3.416}
        y2={16.962}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={23.393}
        x2={30.732}
        y1={23.309}
        y2={38.568}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)